import { render } from "./QuestionRadioButton.vue?vue&type=template&id=34d2c1fa"
import script from "./QuestionRadioButton.vue?vue&type=script&lang=js"
export * from "./QuestionRadioButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__